import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'components/base/Button';
import { CarEvent } from 'providers/CarManagmentProvider';

interface DeleteConfirmationModalProps {
  show: boolean;
  event: CarEvent | null;
  onHide: () => void;
  onDelete: (event: CarEvent) => Promise<void>;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  show,
  event,
  onHide,
  onDelete
}) => {
  const handleDelete = () => {
    if (event) {
      onDelete(event);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      contentClassName="border-translucent"
      centered
    >
      <Modal.Header className="px-card border-0">
        <div className="w-100 d-flex justify-content-between align-items-center">
          <Modal.Title className="mb-0">Eliminar Não operacional</Modal.Title>
          <Button className="p-1 fs-10 text-body" onClick={onHide}>
            X
          </Button>
        </div>
      </Modal.Header>
      <Modal.Body className="p-card py-0">
        <p>
          Tem a certeza que deseja eliminar este registo de não operacional?
        </p>
        <p className="text-muted">
          Esta ação não pode ser desfeita, mas o registo será mantido na base de
          dados (marcado como inativo).
        </p>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end border-0">
        <Button variant="danger" onClick={handleDelete}>
          Eliminar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmationModal;
